import { getCloudUrl } from "Constants";

export const GEOGEBRA_URL = "https://geogebra.org/apps/deployggb.js";

export const DEFAULT_GRAPH_IMAGE_URL = `${getCloudUrl()}/assets/worksheet/GraphPlaceholder.png`;

export const CLASSIC_TOOLBAR_CONFIG_STR =
  "0,73,62 | 1,501,67,5,19,72,75,76 | 2,15,45,18,65,7,37 | 4,3,8,9,13,44,58,47 | 16,51,64,70 | 10,11,20,21,22,23,24,34,53 | 55,56,57,12 | 36,46,38,49,50,71,14,68 | 30,29,55,32,31,33 | 25,17,61 | 40,41,42,27,28,35 | 6 | 77";

export const GEOMETRIC_TOOLBAR_CONFIG_STR =
  "0,73,62,77 | 25,17,61 | 40,41,42,27,28,35,6 | 19,4,8,3,9,13,47 |  36,46,38,49,50 | 1,5,501,67,75,76 | 15,45,2,18,7,37,44,65,58 | 10,11,20,21,22,23,24,34,53  | 16,51,64,70 |  55,56,57,12 |  31,32,30,29,33,54";
// toolbar number references: https://wiki.geogebra.org/en/Reference:Toolbar
